module.exports = __webpack_public_path__ + "img/share-content.db034359.jpg";